export default "__VITE_ASSET__Dyh8t38s__"